import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../utility';

const initialState = {
    google: null,
    map: null,
    searchopen: false,
    center: { lat: -27.988421, lng: 25.025322 },
    place: '',
    mapZoom: 12,
    mapRadius: 11
};

const setGoogle = (state, action) => {
    return updateObject(state, { google: action.google });
};

const setMap = (state, action) => {
    return updateObject(state, { map: action.map });
};

const toggleSearch = (state, action) => {
    return updateObject(state, { searchopen: !state.searchopen, place: state.searchopen ? '' : state.place });
};

const onSearchChange = (state, action) => {
    return updateObject(state, { place: action.place });
};

const onPlaceSelect = (state, action) => {
    return updateObject(state, { place: action.place });
};

const setCenter = (state, action) => {
    return updateObject(state, { center: action.center });
};

const zoomChanged = (state, action) => {
    return updateObject(state, { mapZoom: action.newzoom });
};

const radiusChanged = (state, action) => {
    return updateObject(state, { mapRadius: action.newradius });
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.RESET_APP:
            return initialState;
        case actionTypes.SET_GOOGLE:
            return setGoogle(state, action);
        case actionTypes.SET_MAP:
            return setMap(state, action);
        case actionTypes.SEARCH_TOGGLE:
            return toggleSearch(state, action);
        case actionTypes.ON_SEARCH_CHANGE:
            return onSearchChange(state, action);
        case actionTypes.ON_PLACE_SELECT:
            return onPlaceSelect(state, action);
        case actionTypes.SET_CENTER:
            return setCenter(state, action);
        case actionTypes.ZOOM_CHANGED:
            return zoomChanged(state, action);
        case actionTypes.RADIUS_CHANGED:
            return radiusChanged(state, action);
        default:
            return state;
    }
};

export default reducer;